module.exports = __webpack_public_path__ + "static/media/gen_img11.3cc38232.png";